export class CanceledFilter {
    id: string = "";
    clientId: string = "";
    corporateName: string = "";
    startDate: string = "";
    endDate: string = "";
    searchLimit: boolean = false;
}
